import React, { createContext, useContext, useState, ReactElement, ReactNode } from "react";

interface EntityActionContextType {
    entity: any;
    setEntity: (entity: any) => void;
    actions: ReactElement[];
    setActions: (actions: ReactElement[]) => void;
}

const EntityActionContext = createContext<EntityActionContextType>({
    entity: null,
    setEntity: () => {},
    actions: [],
    setActions: () => {},
});

export const useEntityAction = () => useContext(EntityActionContext);

interface EntityActionProviderProps {
    children: ReactNode;
}

export const EntityActionProvider = ({ children }: EntityActionProviderProps) => {
    const [entity, setEntity] = useState<any>(null);
    const [actions, setActions] = useState<ReactElement[]>([]);

    return (
        <EntityActionContext.Provider value={{ entity, setEntity, actions, setActions }}>
            {children}
        </EntityActionContext.Provider>
    );
};
